import { createFileRoute, Outlet } from "@tanstack/react-router";
import { queryOptions } from "@tanstack/react-query";
import { PublicShell } from "@/components/public/public-shell";
import { getPublicSiteSettings } from "@/lib/public.functions";
import { testimonialsQuery } from "@/components/testimonials-strip";

export const publicSiteSettingsQuery = () =>
  queryOptions({
    queryKey: ["public", "site_settings"],
    queryFn: () => getPublicSiteSettings(),
    staleTime: 5 * 60 * 1000,
  });

export const Route = createFileRoute("/_public")({
  loader: async ({ context }) => {
    // prefetchQuery never throws, so a testimonials failure never blocks a page.
    const [settings] = await Promise.all([
      context.queryClient.ensureQueryData(publicSiteSettingsQuery()),
      context.queryClient.prefetchQuery(testimonialsQuery()),
    ]);
    // Loader data is serialized into the page; the layout copies it back into
    // the browser's query cache so the first browser render matches the
    // server HTML (prevents hydration error #418).
    const testimonials =
      context.queryClient.getQueryData(testimonialsQuery().queryKey) ?? null;
    return { settings, testimonials };
  },
  component: PublicLayout,
});

function PublicLayout() {
  const { settings, testimonials } = Route.useLoaderData();
  const { queryClient } = Route.useRouteContext();
  if (queryClient.getQueryData(publicSiteSettingsQuery().queryKey) === undefined) {
    queryClient.setQueryData(publicSiteSettingsQuery().queryKey, settings);
  }
  if (
    testimonials !== null &&
    queryClient.getQueryData(testimonialsQuery().queryKey) === undefined
  ) {
    queryClient.setQueryData(testimonialsQuery().queryKey, testimonials);
  }
  return (
    <PublicShell>
      <Outlet />
    </PublicShell>
  );
}